import { redirect } from '@tanstack/react-router'

/**
 * Authentication
 * @param context
 */
export const auth = ({ context }) => {
  const { client, setAuthUser } = context
  return client
    .reAuthenticate(false)
    .then((response: any) => {
      context.authUser = response.assettrak_access
      setAuthUser(response.assettrak_access)
      return context
    })
    .catch((error: any) => {
      throw redirect({
        to: '/login',
        search: {
          redirect: window.location.pathname
        }
      })
    })
}

